<template>
  <div>
    <div class="d-flex align-center">
      <v-autocomplete
        v-model="selected"
        :items="items"
        :item-text="formatAddress"
        item-value="id"
        dense
        outlined
        hide-details
        background-color="white"
        class="flex-grow-1"
        :placeholder="'selectAddress'|localize"
        :no-data-text="'noSavedAddresses'|localize"
      />
      <!-- delete control sits next to the field (Miro design): removes the selected address -->
      <v-btn
        icon
        class="ml-2"
        :disabled="!selectedAddress"
        :title="'deleteSavedAddress'|localize"
        @click="onDelete"
      >
        <v-icon>mdi-trash-can-outline</v-icon>
      </v-btn>
    </div>
    <v-dialog v-model="showDeleteDialog" max-width="420">
      <v-card>
        <v-card-title>{{ 'deleteSavedAddress'|localize }}</v-card-title>
        <v-card-text v-if="itemToDelete">{{ formatAddress(itemToDelete) }}</v-card-text>
        <v-card-actions>
          <v-spacer/>
          <v-btn text @click="cancelDelete">{{ 'cancel'|localize }}</v-btn>
          <v-btn text color="error" @click="confirmDelete">{{ 'delete'|localize }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    name: 'SavedAddressSelect',

    props: {
      items: {
        type: Array,
        default: () => [],
      },
    },

    data() {
      return {
        selected: null,
        showDeleteDialog: false,
        itemToDelete: null,
      };
    },

    computed: {
      selectedAddress() {
        return this.items.find(item => item.id === this.selected) || null;
      },
    },

    watch: {
      selected(id) {
        if (!id) return;
        const address = this.items.find(item => item.id === id);
        address && this.$emit('select', address);
      },
      items(list) {
        // the currently selected address may have just been removed from the list — drop the stale selection
        if (this.selected && !list.some(item => item.id === this.selected)) {
          this.selected = null;
        }
      },
    },

    methods: {
      formatAddress(item) {
        const parts = [];
        item.company && parts.push(item.company);
        const street = [item.street_address, item.street_number].filter(Boolean).join(' ');
        street && parts.push(street);
        const cityLine = [item.zip_code, item.city].filter(Boolean).join(' ');
        cityLine && parts.push(cityLine);
        item.country && parts.push(item.country);
        return parts.join(', ');
      },
      onDelete() {
        if (!this.selectedAddress) return;
        this.itemToDelete = this.selectedAddress;
        this.showDeleteDialog = true;
      },
      confirmDelete() {
        this.$emit('delete', this.itemToDelete.id);
        this.showDeleteDialog = false;
        this.itemToDelete = null;
      },
      cancelDelete() {
        this.showDeleteDialog = false;
        this.itemToDelete = null;
      },
    },
  };
</script>
